module.exports = __webpack_public_path__ + "img/10.123dcb8f.png";